export default "__VITE_ASSET__CsZe_D0e__"